import { AlbumDto, CreateAlbumDto } from "../models/Album";
import { axiosInstance } from "./AxiosDefaults";

export const createOneAlbum = (album: CreateAlbumDto): Promise<any> => {
  return axiosInstance.post("/albums", album, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllAlbums = (): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get("/albums", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getOneAlbum = (id: string): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get(`${`/albums`}/${id}`, {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const updateOneAlbum = (id: string, album: AlbumDto): Promise<any> => {
  return axiosInstance.put(`${`/albums`}/${id}`, album, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteOneAlbums = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/albums"}/${id}`);
};
